import {
  Component,
  ContentChildren,
  ElementRef,
  HostBinding,
  HostListener,
  Input,
  OnInit,
  Optional,
  Renderer2,
  Self,
  ViewChild,
} from '@angular/core';
import { ControlValueAccessor, NgControl } from '@angular/forms';
import { IconComponent } from '../icon/icon.component';

@Component({
    selector: 'gl-button-toggle',
    templateUrl: './button-toggle.component.html',
    styleUrls: ['./button-toggle.component.scss'],
    standalone: false
})
export class ButtonToggleComponent implements ControlValueAccessor, OnInit {
  public startingValue: any;
  @Input() public name: string;
  @Input() public value: any;
  @HostBinding('class.no-border') @Input() public noBorder: boolean;
  @ViewChild('input', { static: true }) public input: ElementRef<HTMLInputElement>;
  @ContentChildren(IconComponent, { read: ElementRef }) public icons;

  constructor(
    @Optional()
    @Self()
    public controlDir: NgControl,
    private renderer: Renderer2,
    private elementRef: ElementRef,
  ) {
    if (controlDir) {
      controlDir.valueAccessor = this;
    }
  }

  @HostBinding('class.checked') get checked() {
    return this.input.nativeElement.checked;
  }

  @HostListener('click', ['$event']) public onclick(event) {
    event.preventDefault();
    this.propagateChange(this.value);
    this.setCheckedForInput();
  }

  public ngOnInit() {
    if (this.value === this.startingValue) {
      this.setCheckedForInput();
    }
  }

  public registerOnChange(fn: any): any {
    this.propagateChange = fn;
  }

  public registerOnTouched = (_: any) => undefined;

  public writeValue(value: any): void {
    this.startingValue = value;
    this.renderer.setProperty(this.input.nativeElement, 'value', value);
    if (this.value && this.value === value) {
      this.setCheckedForInput();
    }
  }

  public setDisabledState(isDisabled: boolean): void {
    this.renderer.setProperty(this.elementRef.nativeElement, 'disabled', isDisabled);
  }

  private propagateChange = (_: any) => undefined;

  private setCheckedForInput() {
    this.renderer.setProperty(this.input.nativeElement, 'checked', true);
  }
}
